<template>
  <div class="layout-tkani-card">
    <div ref="images" class="image" v-viewer="viewerOptions">
      <slot name="image"></slot>
    </div>
    <div class="header">
      <div class="title s-18 w-600"><slot name="name"></slot></div>
      <div class="s-14 w-500">
        <slot :selectcheck="selectcheck" :select="select" name="color"></slot>
      </div>
      <div class="s-14 w-500"><slot name="categoria"></slot></div>
      <div class="s-14 w-500"><slot name="typetkani"></slot></div>
      <div class="s-14 w-500"><slot name="sostavtkani"></slot></div>
    </div>

    <div class="has-icon-right" style="position: relative; display: inline-flex; cursor: pointer;">
      <!--  -->
      <ui-tooltip v-model="opened" :opened="opened">
        <div class="s-20 w-500">Запросить образцы ткани </div>
        <ui-tooltip-form :sended="sended">
          <input class="ui-input" required v-model="email" type="email" placeholder="your_email@example.com" />
          <button @click="sendFeedback()"><icon-arrow-right></icon-arrow-right></button>
        </ui-tooltip-form>
        <div class="s-12">
          Оставляя Ваш email, вы соглашаетесь с <a href="" class="underline">политикой</a> обработки персональных данных
        </div>
      </ui-tooltip>
      <!--  -->
      <span @click="opened = true" class="s-14 dashed">Запросить образцы</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    product: {}
  },
  data(){
    return{
      opened: false,
      sended: false,
      email: "",
      select: "",
      viewerOptions: {
        movable: false,
        rotatable: false,
        scalable: false,
        url: 'data-href',
        title: [1, (image, imageData) => `${image.alt}`]
      },
    }
  },
  methods: {
    sendFeedback() {

      let offer = this.product.OFFERS.find(off => off.ID === this.select);

      const EMAIL_REGEXP = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;
      if( this.email === "" || !EMAIL_REGEXP.test(this.email) ){
        this.$notify({group: 'error-form', title: 'error', text: this.$store.state.langs.NOTIFICATION_ERROR_FIELD, type: 'error'});
        return false;
      }

      this.$axios({
        url: '/ajax/?feadback=Y',
        method: 'post',
        params: {
          name: "",
          email: this.email,
          phone: "",
          text: "Запрос образцов ткани - " + offer.NAME + " " + offer.PROPERTIES.TSVET.VALUE + " " + this.product.PROPERTIES.KATEGORIYA.VALUE,
          header: "Запрос образцов ткани - " + offer.NAME + " " + offer.PROPERTIES.TSVET.VALUE + " " + this.product.PROPERTIES.KATEGORIYA.VALUE,
          url: location.href
        }
      }).then(response => {
        if (response.status == 200 && response.data.success) {
          //console.log( "response", response );
          this.sended = true;
          if (typeof (ym) === "function") {
            let yaCounterId = this.$store.state.langs.YACOUNTER;
            ym(yaCounterId, 'reachGoal', 'tkani_sentForm');
          }
        } else {
          console.log('Error feedback tkani_sentForm success: false')
        }
      }).catch(e => {
        console.log('Error: ' + e)
      })
      //this.loading = false;
    },
    selectcheck(event){
      this.select=event.target.value;
      let offer = this.product.OFFERS.find(off => off.ID === this.select);
      let images = this.$refs.images;
      let image = images.getElementsByTagName("img")[0];
      image.src=offer.DETAIL_PICTURE.SRC;
      image.dataset.href=offer.DETAIL_PICTURE.ORIGIN;
    }
  },
  created(){
    let obFilter = this.product.OFFERS;
    obFilter.forEach((el) => {
      if (this.product.OFFER_ID_SELECTED == el.ID) {
           this.select = el.ID
      }
    });
    this.$bus.$on('updateOpened', (eventOpened) => {
      this.opened=eventOpened;
      this.sended = false;
    });
  },
  components: {
    'icon-eye': () => import('@/components/icon/icon-eye.vue'),
    'ui-tooltip': () => import('@/components/ui/ui-tooltip'),
    'ui-tooltip-form': () => import('@/components/ui/ui-tooltip-form'),
    'icon-arrow-right': () => import('@/components/icon/icon-arrow-right')
  }
}
</script>

<style lang="scss" scoped>
.layout-tkani-card {
  display: flex;
  flex-direction: column;
  text-align: left;
}
.image {
  position: relative;
  padding-bottom: 100%;
  overflow: hidden;
  border-radius: 7px;
  * {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.header {
  margin: 10px 0;
}
.title {
  margin-bottom: 10px;
}
.button {
  margin-top: auto;
}
</style>